import React from 'react';

import FieldLabel from 'ui-library/inputs/FieldLabel';
import NumericInput from 'ui-library/inputs/NumericInput';
import {NumericInputChangeEvent} from 'util/Types';

interface PatternAssignmentIntegerInputProps {
  label: string;
  value: number | null;
  onChange: (value: number | null) => void;
  isRequired?: boolean;
}

export default function PatternAssignmentIntegerInput({
  label,
  value,
  onChange,
  isRequired = false,
}: PatternAssignmentIntegerInputProps): JSX.Element {
  return (
    <div>
      <FieldLabel label={label} isRequired={isRequired} />
      <NumericInput
        value={value}
        min={1}
        onChange={(e: NumericInputChangeEvent) => {
          onChange(e.target.numericValue);
        }}
        validateInteger={true}
      />
    </div>
  );
}
